// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/alert.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Comment } from "./comment_pb";
import { file_inventory_v1_comment } from "./comment_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Signal } from "./signal_pb";
import { file_inventory_v1_signal } from "./signal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/alert.proto.
 */
export const file_inventory_v1_alert: GenFile = /*@__PURE__*/
  fileDesc("ChhpbnZlbnRvcnkvdjEvYWxlcnQucHJvdG8SDGludmVudG9yeS52MSKEAwoFQWxlcnQSCgoCaWQYASABKAkSEgoKY29tcGFueV9pZBgCIAEoCRIkCgZzaWduYWwYAyABKAsyFC5pbnZlbnRvcnkudjEuU2lnbmFsEi4KC3dvcmtfc3RhdHVzGAQgASgOMhkuaW52ZW50b3J5LnYxLkFsZXJ0U3RhdHVzEikKCHNldmVyaXR5GAUgASgOMhcuaW52ZW50b3J5LnYxLlJpc2tMZXZlbBI1Cg9tYW51YWxfc2V2ZXJpdHkYBiABKA4yFy5pbnZlbnRvcnkudjEuUmlza0xldmVsSACIAQESLwoMd2lubmluZ19ydWxlGAcgASgLMhkuaW52ZW50b3J5LnYxLldpbm5pbmdSdWxlEi4KCmNyZWF0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQhIKEF9tYW51YWxfc2V2ZXJpdHkiWQoLV2lubmluZ1J1bGUSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRIwCg9lbmdpbmVfc2V2ZXJpdHkYAyABKA4yFy5pbnZlbnRvcnkudjEuUmlza0xldmVsIqkDCgtBbGVydENoYW5nZRIoCgR0aW1lGAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBI4ChBwcmV2X3dvcmtfc3RhdHVzGAIgASgOMhkuaW52ZW50b3J5LnYxLkFsZXJ0U3RhdHVzSACIAQESNwoPbmV3X3dvcmtfc3RhdHVzGAMgASgOMhkuaW52ZW50b3J5LnYxLkFsZXJ0U3RhdHVzSAGIAQESMwoNcHJldl9zZXZlcml0eRgEIAEoDjIXLmludmVudG9yeS52MS5SaXNrTGV2ZWxIAogBARIyCgxuZXdfc2V2ZXJpdHkYBSABKA4yFy5pbnZlbnRvcnkudjEuUmlza0xldmVsSAOIAQESKwoHY29tbWVudBgGIAEoCzIVLmludmVudG9yeS52MS5Db21tZW50SASIAQESDwoHdXNlcl9pZBgHIAEoCUITChFfcHJldl93b3JrX3N0YXR1c0ISChBfbmV3X3dvcmtfc3RhdHVzQhAKDl9wcmV2X3NldmVyaXR5Qg8KDV9uZXdfc2V2ZXJpdHlCCgoIX2NvbW1lbnQiewoRQWxlcnRUaW1lbGluZUl0ZW0SKwoGY2hhbmdlGAEgASgLMhkuaW52ZW50b3J5LnYxLkFsZXJ0Q2hhbmdlSAASKAoHY29tbWVudBgCIAEoCzIVLmludmVudG9yeS52MS5Db21tZW50SABCDwoNdGltZWxpbmVfaXRlbSqzAQoLQWxlcnRTdGF0dXMSHAoYQUxFUlRfU1RBVFVTX1VOU1BFQ0lGSUVEEAASFQoRQUxFUlRfU1RBVFVTX09QRU4QARIYChRBTEVSVF9TVEFUVVNfT05HT0lORxACEhkKFUFMRVJUX1NUQVRVU19BQ0NFUFRFRBADEhkKFUFMRVJUX1NUQVRVU19SRVNPTFZFRBAEEh8KG0FMRVJUX1NUQVRVU19OT1RfQVBQTElDQUJMRRAFQrIBChBjb20uaW52ZW50b3J5LnYxQgpBbGVydFByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_google_protobuf_timestamp, file_inventory_v1_comment, file_inventory_v1_risk, file_inventory_v1_signal]);

/**
 * Alert is the user-facing view of a Signal that was promoted by a rule.
 * Carries alert-lifecycle state and the winning rule context. All raw signal
 * data (title / description / etc.) lives on the embedded `signal` field —
 * the FE accesses `alert.signal.title`, never an `alert.title`.
 *
 * @generated from message inventory.v1.Alert
 */
export type Alert = Message<"inventory.v1.Alert"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string company_id = 2;
   */
  companyId: string;

  /**
   * The underlying signal. Non-optional — alerts always derive from a signal.
   *
   * @generated from field: inventory.v1.Signal signal = 3;
   */
  signal?: Signal;

  /**
   * @generated from field: inventory.v1.AlertStatus work_status = 4;
   */
  workStatus: AlertStatus;

  /**
   * Resolved severity: manual_severity ?? winning_rule.engine_severity ??
   * signal_type.default_level. The FE displays this; manual_severity below
   * is exposed separately so the FE can render an "overridden" badge.
   *
   * @generated from field: inventory.v1.RiskLevel severity = 5;
   */
  severity: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.RiskLevel manual_severity = 6;
   */
  manualSeverity?: RiskLevel;

  /**
   * The rule whose evaluation produced this alert. Non-optional — an alert
   * is by definition a signal with a winning rule attached. When the rule is
   * hard-deleted the signal's winning_rule_id is cleared and the row stops
   * being an alert (so it doesn't surface on ListAlerts/GetAlert), until the
   * engine's next whole-org recompute potentially promotes it again under a
   * different rule.
   *
   * @generated from field: inventory.v1.WinningRule winning_rule = 7;
   */
  winningRule?: WinningRule;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message inventory.v1.Alert.
 * Use `create(AlertSchema)` to create a new message.
 */
export const AlertSchema: GenMessage<Alert> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert, 0);

/**
 * WinningRule packages the alert's rule-attribution data so the FE can deep-
 * link to the rule that fired (`/settings/alert-rules/:id`) and render the
 * engine-assigned severity alongside any manual override on the parent Alert.
 *
 * @generated from message inventory.v1.WinningRule
 */
export type WinningRule = Message<"inventory.v1.WinningRule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: inventory.v1.RiskLevel engine_severity = 3;
   */
  engineSeverity: RiskLevel;
};

/**
 * Describes the message inventory.v1.WinningRule.
 * Use `create(WinningRuleSchema)` to create a new message.
 */
export const WinningRuleSchema: GenMessage<WinningRule> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert, 1);

/**
 * AlertChange is one entry in an alert's change history (status / severity
 * transitions, false-positive flips that hide the alert). Mirrors
 * db/gorm/model/signal_change.go's OrgSignalChange row shape.
 *
 * @generated from message inventory.v1.AlertChange
 */
export type AlertChange = Message<"inventory.v1.AlertChange"> & {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * @generated from field: optional inventory.v1.AlertStatus prev_work_status = 2;
   */
  prevWorkStatus?: AlertStatus;

  /**
   * @generated from field: optional inventory.v1.AlertStatus new_work_status = 3;
   */
  newWorkStatus?: AlertStatus;

  /**
   * @generated from field: optional inventory.v1.RiskLevel prev_severity = 4;
   */
  prevSeverity?: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.RiskLevel new_severity = 5;
   */
  newSeverity?: RiskLevel;

  /**
   * @generated from field: optional inventory.v1.Comment comment = 6;
   */
  comment?: Comment;

  /**
   * @generated from field: string user_id = 7;
   */
  userId: string;
};

/**
 * Describes the message inventory.v1.AlertChange.
 * Use `create(AlertChangeSchema)` to create a new message.
 */
export const AlertChangeSchema: GenMessage<AlertChange> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert, 2);

/**
 * AlertTimelineItem is one entry in the alert's timeline: either a state
 * change or a free-form comment. Comments are stored against the underlying
 * signal (one comment thread per signal/alert pair); state changes are
 * alert-lifecycle.
 *
 * @generated from message inventory.v1.AlertTimelineItem
 */
export type AlertTimelineItem = Message<"inventory.v1.AlertTimelineItem"> & {
  /**
   * @generated from oneof inventory.v1.AlertTimelineItem.timeline_item
   */
  timelineItem: {
    /**
     * @generated from field: inventory.v1.AlertChange change = 1;
     */
    value: AlertChange;
    case: "change";
  } | {
    /**
     * @generated from field: inventory.v1.Comment comment = 2;
     */
    value: Comment;
    case: "comment";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.AlertTimelineItem.
 * Use `create(AlertTimelineItemSchema)` to create a new message.
 */
export const AlertTimelineItemSchema: GenMessage<AlertTimelineItem> = /*@__PURE__*/
  messageDesc(file_inventory_v1_alert, 3);

/**
 * AlertStatus is the work-status lifecycle of an alert. The wire-string values
 * are intentionally retained as "FINDING_STATUS_*" — they are the on-disk DB
 * format and survive the proto rename. See api/types/alert_status.go.
 *
 * @generated from enum inventory.v1.AlertStatus
 */
export enum AlertStatus {
  /**
   * @generated from enum value: ALERT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ALERT_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: ALERT_STATUS_ONGOING = 2;
   */
  ONGOING = 2,

  /**
   * @generated from enum value: ALERT_STATUS_ACCEPTED = 3;
   */
  ACCEPTED = 3,

  /**
   * @generated from enum value: ALERT_STATUS_RESOLVED = 4;
   */
  RESOLVED = 4,

  /**
   * @generated from enum value: ALERT_STATUS_NOT_APPLICABLE = 5;
   */
  NOT_APPLICABLE = 5,
}

/**
 * Describes the enum inventory.v1.AlertStatus.
 */
export const AlertStatusSchema: GenEnum<AlertStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_alert, 0);

